import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";
import { Overline } from "./Motion";

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative bg-royal-deep text-white py-28 lg:py-40 overflow-hidden grain">
      <div className="pointer-events-none absolute -left-16 -top-10 font-display text-[22vw] leading-none text-white/[0.03] select-none">
        01—03
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <Overline light>Our manifesto</Overline>
        <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight max-w-3xl">
          A company driven by <span className="italic text-white/70">conviction and excellence.</span>
        </h2>

        <div className="mt-20 space-y-px">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              data-testid={`manifesto-${m.no}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-start py-10 border-t border-white/10"
            >
              <div className="lg:col-span-2 font-display text-4xl lg:text-5xl text-white/40">{m.no}</div>
              <h3 className="lg:col-span-5 font-display text-3xl lg:text-4xl tracking-tight">{m.title}</h3>
              <p className="lg:col-span-5 text-white/70 lg:text-lg leading-relaxed">{m.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
